export default __webpack_public_path__ + "static/logo-afcbd352e0ace357d0c07a9c9283a768.svg";